import React, { useState, useCallback, useEffect } from "react";
import { Container, Label, ContentFlex, LabelContent } from "./styles";
import Select from "react-select";
import { RenderIf } from "../../../../../RenderIf";
import { producaov2 as api } from "../../../../../../services/apis";

function TreinamentoSearchInputMultiple({
  handleChange,
  initiateValue,
  remove,
  selectedCursos,
  setSelectedCursos,
  hideLabel = false,
  ...props
}) {
  const [courseOptions, setCourseOptions] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);

  const handleTreinamentoChange = useCallback(search => {
    const cleanSearch = search.toLowerCase().trim();

    const params = {
      search_id_curso: 1,
      allReduced: 1,
      ativo: "S",
    };

    if (search) {
      params.nome = search;
    }

    api.get("/admin/treinamentos", { params }).then(res => {
      if (res.data.length > 0) {
        const options = res.data
          .filter(
            elem =>
              elem.curso.toString().includes(cleanSearch) ||
              elem.nome.toLowerCase().includes(cleanSearch)
          )
          .map(c => ({
            label: `(${c.nome})[ID: ${c.curso || c.id}]`,
            value: c.id,
          }));

        setCourseOptions(options);
      } else {
        setCourseOptions([]);
      }
    });
  }, []);

  const handleDropdownChange = selectedOptions => {
    setSelectedOptions(selectedOptions);
    setCourseOptions([]);

    handleChange(selectedOptions);
  };

  useEffect(() => {
    if (initiateValue) {
      setSelectedCursos(initiateValue);
    }
  }, [initiateValue]);

  const customStyles = {
    control: styles => ({
      ...styles,
      width: "100%",
      "&:hover": {
        cursor: "pointer",
        borderColor: "black", // Cor da borda ao passar o mouse
      },
    }),
    multiValue: styles => ({
      ...styles,
      // backgroundColor: "orange", // Cor de fundo do valor selecionado
    }),
    multiValueLabel: styles => ({
      ...styles,
      // color: "white", // Cor do texto do valor selecionado
    }),
    multiValueRemove: styles => ({
      ...styles,
      ":hover": {
        backgroundColor: "red", // Cor de fundo ao passar o mouse sobre o ícone de remoção
        color: "white",
      },
    }),
    option: (styles, { isFocused }) => ({
      ...styles,
      backgroundColor: isFocused ? "#ccc" : "transparent",
      color: "black",
      "&:hover": {
        cursor: "pointer",
      },
    }),
  };

  return (
    <>
      <Container>
        <div>
          <RenderIf isTrue={!hideLabel}>
            <Label>Selecione os cursos que este cupom contempla:</Label>
          </RenderIf>
        </div>
      </Container>
      <Select
        isMulti
        options={courseOptions}
        onInputChange={handleTreinamentoChange}
        onChange={handleDropdownChange}
        value={selectedOptions}
        placeholder="Selecione ao menos um curso..."
        styles={customStyles}
        theme={theme => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary: "black",
            primary75: "black",
            primary50: "grey",
          },
        })}
      />
    </>
  );
}

export default TreinamentoSearchInputMultiple;
